
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prizes",
      function () {
        return require("private-next-pages/prizes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prizes"])
      });
    }
  